const COLORS = {
  green: "#00aa7e",
  lightGreen: "#e6fff8",
  blue: "#224880",
  lightBlue: "#f0f4ff",
  orange: "#f0a202",
  lightOrange: "#fff7e6",
  red: "#dc3545",
  lightRed: "#fbe9eb",
  disabledGrey: "#979797"
};

export default COLORS;
